// extracted by mini-css-extract-plugin
export default {"panel":"CreateDetailsPanel_panel__IpKc9","controls":"CreateDetailsPanel_controls__B-Yrw"};